var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.542v-.029c-.008-.552-.226-1.071-.617-1.463-.398-.398-.927-.618-1.49-.618H8.985c-.288-1.248-1.406-2.18-2.738-2.181l-1.92-.001c-1.549 0-2.81 1.262-2.81 2.814v7.872c0 1.552 1.261 2.814 2.81 2.814h3.41c.388 0 .703-.315.703-.704 0-.388-.315-.703-.703-.703h-3.41c-.774 0-1.405-.631-1.405-1.407V5.064c.001-.776.631-1.407 1.405-1.407h1.92c.774.001 1.404.632 1.404 1.408v.07c0 .39.315.704.703.704h6.039c.187 0 .364.073.496.206.128.128.2.296.206.475v.118c0 .362.293.655.655.655.414 0 .75-.336.75-.75v-.001z",
    transform: "translate(-1149.000000, -345.000000) translate(1040.000000, 0.000000) translate(100.000000, 336.000000) translate(9.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.723 11.191h-.317v-.738c0-.388-.315-.703-.703-.703-.388 0-.703.315-.703.703v1.442c0 .388.315.703.703.703h1.02c.388 0 .703-.315.703-.703 0-.389-.315-.704-.703-.704z",
    transform: "translate(-1149.000000, -345.000000) translate(1040.000000, 0.000000) translate(100.000000, 336.000000) translate(9.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.504 7.5c-2.346 0-4.254 1.908-4.254 4.254 0 2.346 1.908 4.254 4.254 4.254 2.346 0 4.254-1.908 4.254-4.254 0-2.346-1.908-4.254-4.254-4.254zm0 7.102c-1.57 0-2.848-1.278-2.848-2.848 0-1.57 1.278-2.848 2.848-2.848 1.57 0 2.848 1.278 2.848 2.848 0 1.57-1.278 2.848-2.848 2.848z",
    transform: "translate(-1149.000000, -345.000000) translate(1040.000000, 0.000000) translate(100.000000, 336.000000) translate(9.000000, 9.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchive);
export default __webpack_public_path__ + "static/media/icon-archive.90fc94f5a26e98039cd00a9fc344b4b0.svg";
export { ForwardRef as ReactComponent };